<template>
  <div id="demo" class="container">
    <section class="container__empty" v-if="!rooms.length">
      <p class="text-center">
        暂无信息，请先
        <router-link to="/courses">购买直播课</router-link>
      </p>
    </section>
    <section v-else>
      <div class="number">
        <em>1</em>
      </div>
      <img src="https://cdn.anyteach.cn/live/how-to-join/download.jpg" />
      <div class="number">
        <em>2</em>
      </div>
      <div v-if="!is_orgs_user">
        <p class="desc">
          打开 CCtalk 搜索以下房间，
          <br />进入教室并填写您在 AnyTeach 留下的手机号码
        </p>
        <br />
        <div v-for="item in rooms" :key="item.order_id">
          <Card :room="item.roomList" class="code-wrapper" />
        </div>
      </div>
      <div v-else>
        <img class="search" src="https://cdn.anyteach.cn/live/how-to-join/search.jpg" />
        <p class="desc">打开 CCtalk 搜索房间名，或点击链接在微信内打开</p>
        <p class="note">微信内上课无法与老师互动，推荐使用手机 app</p>
        <br />
        <div v-for="item in rooms" :key="item.order_id">
          <Card
            v-if="item.roomList.rooms.length"
            :room="item.roomList"
            class="code-wrapper"
            :is_orgs_user="true"
          />
        </div>
      </div>
      <div class="number">
        <em>3</em>
      </div>
      <div class="cs">
        <p class="desc">
          扫码添加小管家微信
          <br />享受个性化服务
        </p>
        <div class="qr">
          <h1 v-if="cs && cs.qr_url">{{ cs.name }}</h1>
          <h1 v-else>AnyTeach 小管家 2</h1>
          <img v-if="cs && cs.qr_url" :src="cs.qr_url" />
          <img v-else src="https://cdn.anyteach.cn/cs-2.jpeg" />
          <a v-if="cs && cs.phone" :href="'tel:' + cs.phone" class="call">
            <i class="anyteachicon anyteach-phone" />
            <span>致电咨询</span>
          </a>
          <a v-else href="tel:4000396999" class="call">
            <i class="anyteachicon anyteach-phone" />
            <span>致电咨询</span>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Room from "./Room"
import Card from "./Card"

export default {
  name: "Demo",
  components: { Room, Card },
  props: {
    is_orgs_user: {
      type: Boolean,
      default: false,
    },
    cs: {
      type: Object,
      default: Object,
    },
    rooms: {
      type: Array,
      default: Array,
    },
  },
}
</script>
<style lang="scss" scoped>
@import "./style.scss";
// @import "../../../../static/css/public.scss";
</style>
